export default class SupHeaderModule{

    constructor(element) {
        this.$wrapper = element;
        this.$close =  this.$wrapper.querySelectorAll('.js-sup-header-close');
        this.bindEvents();
        this.checkSession();
    }

    bindEvents(){
        [].forEach.call(this.$close, ($trigger, index) => {
            $trigger.addEventListener('click', this.setSession.bind(this));
        });
    }

    setSession(){
        sessionStorage.setItem('hide_supheader', true);
        this.hideWrapper();
    }

    checkSession(){
        if(sessionStorage.getItem('hide_supheader')){
            this.hideWrapper();
        }
    }

    hideWrapper(){
        this.$wrapper.classList.add('is-clicked');
        document.body.classList.remove('suphead-shown');
    }


}